import { globalLogger } from '../../helper/global-logger';
import { satGlobals } from '../../sat/helper/sat-globals';
import { AuthFormValidator } from '../../../lib-sat/user/auth-form-validator';
import { CaptchaHelper } from '../../../lib-sat/captcha/captcha';
import { pageNotification } from '../../helper/notify';
import { satUserManager } from '../../../lib-sat/user/sat-user';
import { axiosWrapper } from '../../../lib/axios-wrapper/axios-wrapper';
import { csrfManager } from '../../../lib-sat/csrf/csrf-manager';
import { testIsNotUndefined } from '../../../lib/test-and-assert/test-base';

global.qgCaptcha = new CaptchaHelper();
/**
 * This is only here to trigger the download of the user info so that it is available earlier
 * in subsequent call
 */
satUserManager.getUserDataDeprecated().done((userData) => {
    if (userData.meData.extra.is_impersonated) {
        let warning = document.createElement('div');
        warning.classList.add('sticky-top', 'alert', 'alert-danger', 'text-center', 'm-b-0');
        warning.innerHTML = 'ATTENTION: Impersonated user';

        document.body.prepend(warning);
    }
});

window.qgAuthFormValidator = new AuthFormValidator();

class QgAuthCaptcha {
    constructor() {
        if (window.sat.captcha === false) {
            return;
        }
        let _this = this;
        this.captchaMethod = 'none';
        this.captchaData = {};
        this.captchaToken = 'no_token';
        this.callbackCaptcha = function () {};

        qgCaptcha.init({
            sitekey: window.sat.gRecaptchaSitekey,
            callback: (token) => {
                this.captchaToken = token;

                this.callbackCaptcha();
            },
        });
    }

    init() {}

    /**
     * @param {Function} callback
     */
    setCallback(callback) {
        this.callbackCaptcha = callback;
    }

    /**
     * @returns {string}
     */
    getCaptchaToken() {
        return this.captchaToken;
    }
}

window.qgAuthCaptcha = new QgAuthCaptcha();
window.qgAuthCaptcha.init();

class QgAuthLogin {
    constructor() {
        this.formValidator = new AuthFormValidator();
    }

    init(errorMessages) {
        const _this = this;

        $(document).ready(function () {
            var config = {
                errorMessages: errorMessages,
            };

            _this.formValidator.init(config);
        });

        $('#functional-submit-btn').on('click', function (e) {
            $('#functional-submit-btn').find('i').removeClass('fa-sign-in').addClass('fa-spinner fa-spin');
            e.preventDefault();

            _this.login();
        });
    }

    login() {
        window.allowLeave = true;
        const _this = this;

        var isUsernameValid = _this.formValidator.processUsername();
        var isPasswordValid = _this.formValidator.processPassword(false);

        if (isUsernameValid !== true || isPasswordValid !== true) {
            globalLogger.log(
                'user login - validation - fail',
                'valid password: ' + isPasswordValid + ' valid username: ' + isUsernameValid
            );

            _this.formValidator.scrollToError();

            return false;
        }

        window.qgAuthCaptcha.callbackCaptcha = function () {
            if (window.qgAuthCaptcha.captchaToken !== 'undefined') {
                if (window.qgAuthCaptcha.captchaToken.length === 0) {
                    window.qgLogger.log('user login - recaptcha - fail');

                    return;
                }
            }

            window.qgLogger.log('user login - validation - done');
            window.allowLeave = true;

            window.qgAuthLogin.login();

            return;
        };

        axiosWrapper
            .get(satGlobals.getApiUrl('api/csrf/login'))
            .then((/**AxiosResponse*/ response) => {
                var data = {
                    _api_username: $('#username').val(),
                    _api_password: $('#password').val(),
                    _csrf: response?.data?.token,
                };

                if (window.qgAuthCaptcha.captchaToken !== 'no_token') {
                    data.captcha = window.qgAuthCaptcha.captchaToken;
                }

                var options = {
                    url: sat.apiUrl + '/api/user/login',
                    xhrFields: {
                        withCredentials: true,
                    },
                    data: data,
                };

                window.allowLeave = true;

                axiosWrapper
                    .post(satGlobals.getApiUrl('/api/user/login'), data)
                    .then((/** AxiosResponse */ response) => {
                        window.location.href = response?.data?.url;
                    })
                    .catch((/** AxiosError*/ error) => {
                        if (error?.response?.data?.message === 'invalid_captcha') {
                            qgCaptcha.captcha();
                        } else {
                            if (error?.response.status === 429) {
                                pageNotification.error('Too many requests. Please try again later.');
                            }

                            pageNotification.error(
                                'Sorry, something went wrong. Please try again, or refresh the page.'
                            );
                        }
                    });

                $.post(options)
                    .done(function (a) {})
                    .fail(function (jqXHR, textStatus, errorThrown) {});
            })
            .catch((/** AxiosError*/ error) => {});
    }

    addCaptcha(token) {
        $('<input>')
            .attr({
                type: 'hidden',
                id: 'captcha',
                name: 'captcha',
                value: token,
            })
            .appendTo('#authForm');
    }
}

window.qgAuthLogin = new QgAuthLogin();

class QgAuthRegister {
    constructor() {
        this.formValidator = new AuthFormValidator();
    }

    init(errorMessages) {
        var submitIcon = 'fa-user-plus';

        const _this = this;

        $(document).ready(function () {
            var config = {
                errorMessages: errorMessages,
            };

            _this.formValidator.init(config);
        });

        var idUser = 0;

        $('#functional-submit-btn').on('click', function (e) {
            e.preventDefault();

            var isEmailValid = _this.formValidator.processEmail();
            var isPasswordValid = _this.formValidator.processPassword(true);
            var isTosValid = _this.formValidator.processTos();

            if (isEmailValid !== true || isPasswordValid !== true || isTosValid !== true) {
                globalLogger.log(
                    'user registration - validation - fail',
                    'valid email: ' + isEmailValid + ' valid password: ' + isPasswordValid + ' valid tos: ' + isTosValid
                );

                _this.formValidator.scrollToError();

                return false;
            }

            globalLogger.log('user registration - validation - done');

            $(this).prop('disabled', true).find('i').removeClass(submitIcon).addClass('fa-spinner fa-spin');
            _this.registerUser('no_token');
        });
    }

    registerUser(captchaToken) {
        globalLogger.log('user.js - registerUser still used');
        var data = {
            _email: $('input[name=_email]').val(),
            _password: $('input[name=_password]').val(),
            _newsletter: $('input[name=_newsletter]').is(':checked'),
            tos: $('input[name=tos]').val(),
            _csrf: $('input[name=_csrf]').val(),
            _user_locale: satGlobals.getLocale(),
        };

        if (window.qgAuthCaptcha.captchaToken !== 'no_token') {
            data.captcha = window.qgAuthCaptcha.captchaToken;
        }

        var options = {
            url: satGlobals.getApiUrl('/api/client/user/register?registermethod=modal'),
            xhrFields: {
                withCredentials: true,
            },
            data: data,
        };

        const _this = this;

        $.post(options)
            .done(function (msg) {
                //window.location = "{{ absolute_url(path('registerSuccess')) }}";
                localStorage.setItem('qgUser', msg.user);
                if (sat.modal === true) {
                    var optionsModal = {
                        url: satGlobals.getApiUrl('/api/tpl/subscribe'),
                        xhrFields: {
                            withCredentials: true,
                        },
                        cache: false,
                    };
                    $.get(optionsModal, function (data) {
                        $('#authModal').find('.modal-body').html(data);
                        initSubscribeCode();
                    });
                } else {
                    window.allowLeave = true;
                    window.location = sat.register_success;
                }
            })
            .fail(function (xhr, status, error) {
                var submitIcon = 'fa-user-plus';

                $('#functional-submit-btn')
                    .prop('disabled', false)
                    .find('i')
                    .addClass(submitIcon)
                    .removeClass('fa-spinner fa-spin');

                var failData = JSON.parse(xhr.responseText);

                if (failData.hasOwnProperty('message')) {
                    if (failData.message === 'email_unsupported') {
                        _this._showInvalidMail();
                    }
                    if (failData.message === 'invalid_captcha') {
                        window.qgAuthCaptcha.callbackCaptcha = function () {
                            window.qgLogger.log('user registration - recaptcha - done');

                            window.qgAuthRegister.registerUser('token');

                            return;
                        };

                        qgCaptcha.captcha();

                        return;
                    }
                } else {
                    location.reload();
                }
            });
    }

    _showInvalidMail() {
        $('.invalid-mail-hidden').addClass('hidden');
        $('#functional-submit-btn')
            .prop('disabled', false)
            .find('i')
            .removeClass('fa-spinner fa-spin')
            .addClass('fa-user-plus');

        $('#invalid-mail').removeClass('hidden');
    }
}

window.qgAuthRegister = new QgAuthRegister();

class QgAuthRegisterSuccess {
    constructor() {}

    init() {
        $(document).ready(function () {
            $('#getPremium').on('click', function (e) {
                e.preventDefault();

                if (sat.modal === true) {
                    var options = {
                        url: satGlobals.getApiUrl('/api/tpl/subscribe'),
                        xhrFields: {
                            withCredentials: true,
                        },
                        cache: false,
                    };

                    $.get(options, function (data) {
                        $('#authModal').find('.modal-body').html(data);
                    });
                } else {
                    window.location = sat.registerUrl;
                }
            });

            /*
            qgCaptcha.init({
                sitekey: sat.gRecaptchaSitekey,
                callback: function(token) {
                    var data = {
                        _email: $('input[name="_email"]').val()
                    };

                    if (typeof token !== 'undefined') {
                        if (token.length === 0) {
                            globalLogger.log('user registration - confirmation - recaptcha - fail');

                            $('#functional-submit-btn')
                                .prop('disabled', false)
                                .find('i')
                                .removeClass('fa-spinner fa-spin')
                                .addClass('fa-repeat');

                            return;
                        }

                        data.captcha = token;
                    }

                    var options = {
                        type: 'POST',
                        url: sat.registerResend,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: data
                    };

                    $.ajax(options)
                        .done(function() {
                            globalLogger.log('user registration - confirmation - email - resend - done');
                        })
                        .fail(function() {
                            globalLogger.log('user registration - confirmation - email - resend - fail');
                        })
                        .always(function() {
                            setTimeout(function() {
                                $('#functional-submit-btn')
                                    .prop('disabled', false)
                                    .find('i')
                                    .removeClass('fa-spinner fa-spin')
                                    .addClass('fa-repeat');
                            }, 3000);
                        });
                }
            }); */
        });

        $('#functional-submit-btn').on('click', function () {
            $(this).prop('disabled', true).find('i.fa').removeClass('fa-repeat').addClass('fa-spinner fa-spin');
            qgCaptcha.captcha();
        });
    }
}

window.qgAuthRegisterSuccess = new QgAuthRegisterSuccess();

class QgAuthSubscribe {
    constructor() {
        this.chosenPlan = 'free';
        this.stripe = null;
    }

    init() {
        let _this = this;
        $('.btn-cc').attr('disabled', false);
        _this.chosenPlan = agreements.free;
        var plan = 'free';

        $(document).on('click', '#paymentAnnual', function (e) {
            $(this)
                .parent()
                .find('.premium-bg')
                .removeClass('active')
                .removeClass('premium-bg')
                .removeClass('text-white')
                .addClass('btn-white');
            $(this).addClass('active').addClass('premium-bg').addClass('text-white');
            chooseAnnual(e);
        });

        $(document).on('click', '#paymentFree', function (e) {
            $(this)
                .parent()
                .find('.premium-bg')
                .removeClass('active')
                .removeClass('premium-bg')
                .removeClass('text-white')
                .addClass('btn-white');
            $(this).addClass('active').addClass('premium-bg').addClass('text-white');
            chooseFree(e);
        });

        $(document).on('click', '#paymentMonthly', function (e) {
            $(this)
                .parent()
                .find('.premium-bg')
                .removeClass('active')
                .removeClass('premium-bg')
                .removeClass('text-white')
                .addClass('btn-white');
            $(this).addClass('active').addClass('premium-bg').addClass('text-white');
            chooseMonthly(e);
        });

        var chooseAnnual = function () {
            plan = 'annual';
            _this.chosenPlan = agreements.annual;
            $('#plan-text-monthly, .plan-text-monthly').addClass('hidden');
            $('#plan-text-annual, .plan-text-annual').removeClass('hidden');
            $('.name-premium').removeClass('hidden');
            $('.name-free').addClass('hidden');

            $('.currentPrice').html(agreementsPrice.annual);
            $('.subInterval').html(
                agreementsInterval.annual + ' <strong>' + agreementsPrice.annual_total + '</strong>'
            );
        };

        var chooseMonthly = function () {
            plan = 'annual';
            _this.chosenPlan = agreements.month;
            $('#plan-text-monthly, .plan-text-monthly').removeClass('hidden');
            $('#plan-text-annual, .plan-text-annual').addClass('hidden');
            $('.name-premium').removeClass('hidden');
            $('.name-free').addClass('hidden');

            $('.currentPrice').html(agreementsPrice.monthly);
            $('.subInterval').html(agreementsInterval.monthly);
        };

        var chooseFree = function () {
            plan = 'free';
            _this.chosenPlan = agreements.free;
            $('#plan-text-monthly, .plan-text-monthly').addClass('hidden');
            $('#plan-text-annual, .plan-text-annual').addClass('hidden');
            $('.name-premium').addClass('hidden');
            $('.name-free').removeClass('hidden');

            $('.currentPrice').html(agreementsPrice.free);
            $('.subInterval').html(agreementsInterval.free);
        };

        satUserManager.getUserDataDeprecated().done((userData) => {
            if (userData.isRegistered) {
                chooseAnnual();
            } else {
                chooseAnnual();
            }
        });

        $(document).on('click', '#pStepNext', function (e) {
            if (_this.chosenPlan === 'free') {
                if (sat.modal === true) {
                    var options = {
                        url: satGlobals.getApiUrl('/api/tpl/register-success'),
                        cache: false,
                        xhrFields: {
                            withCredentials: true,
                        },
                    };

                    $.get(options, function (data) {
                        $('#authModal').find('.modal-body').html(data);
                    });
                } else {
                    window.allowLeave = true;
                    window.location = sat.register_success;
                }
            } else {
                $('#pStep1').hide();
                $('#pStep2').show();
            }
        });

        $(document).on('click', '#pStepBack', function (e) {
            $('#pCreditCard').hide();
            $('#pStep2').hide();
            $('#pStep1').show();
            $('.btn-cc').attr('disabled', false);
        });

        $(document).on('click', '#pay-paypal', function (e) {
            $('#pStep2').hide();
            $('#pPaypal').show();
            window.setTimeout(processPaymentPayPal, 3000);
        });

        $(document).on('click', '#pay-creditcard', function (e) {
            $('#pStep2').hide();
            $('#pCreditCard').show();
            initPaymentStripe();
        });

        function processPaymentPayPal() {
            csrfManager
                .getCsrfPayment()
                .then((token) => {
                    var ppChosenPlan = 'pp_' + _this.chosenPlan;

                    var data = {};
                    var user = localStorage.getItem('qgUser');
                    if (null !== user) {
                        data.user = user;
                    }

                    data._csrf = token;

                    var options = {
                        url: satGlobals.getApiUrl(
                            '/api/payment/paypal/agreement/approval?plan=' + ppChosenPlan + '&subscribemethod=modal'
                        ),
                        cache: false,
                        xhrFields: {
                            withCredentials: true,
                        },
                        data: data,
                    };

                    $.post(options)
                        .done(function (msg) {
                            try {
                                var data = JSON.parse(msg);
                            } catch (e) {
                                location.reload();
                            }
                            window.allowLeave = true;
                            window.location = data.approval_link;
                        })
                        .fail(function (xhr, status, error) {
                            var url = window.location.href;
                            if (url.indexOf('?plan') > -1) {
                                url = window.location.href;
                            } else {
                                url += '?plan=' + plan;
                            }
                            window.allowLeave = true;
                            window.location.href = sat.registerUrl;
                        });
                })
                .fail(() => {
                    globalLogger.log('user registration - get payment csrf token - fail');
                });
        }

        function initPaymentStripe() {
            _this.stripe = Stripe(sat.stripe_pk);
            var elements = _this.stripe.elements({
                locale: satGlobals.getLocale(),
            });

            var elementStyles = {
                base: {
                    color: '#32325D',
                    fontWeight: 500,
                    fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',

                    '::placeholder': {
                        color: '#CFD7DF',
                    },
                    ':-webkit-autofill': {
                        color: '#e39f48',
                    },
                },
                invalid: {
                    color: '#E25950',

                    '::placeholder': {
                        color: '#FFCCA5',
                    },
                },
            };
            var elementClasses = {
                focus: 'focused',
                empty: 'empty',
                invalid: 'invalid',
            };

            var cardNumber = elements.create('cardNumber', {
                style: elementStyles,
                classes: elementClasses,
            });
            cardNumber.mount('#card-number');

            var cardExpiry = elements.create('cardExpiry', {
                style: elementStyles,
                classes: elementClasses,
            });
            cardExpiry.mount('#card-expiry');

            var cardCvc = elements.create('cardCvc', {
                style: elementStyles,
                classes: elementClasses,
            });
            cardCvc.mount('#card-cvc');

            cardNumber.addEventListener('change', function (event) {
                var displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            var form = document.getElementById('payment-form');
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                $('.btn-cc').attr('disabled', true);

                if (satGlobals.getEnableFreeTrial()) {
                    _this.setupIntent(cardNumber);
                } else {
                    _this.paymentMethod(cardNumber);
                }
            });
        }
    }

    setupIntent(cardNumber) {
        csrfManager.getCsrfPayment().then((token) => {
            let _this = this;
            var data = {};
            var user = localStorage.getItem('qgUser');

            if (null !== user) {
                data.user = user;
            }

            if (window.qgAuthCaptcha.captchaToken !== 'no_token') {
                data.captcha = window.qgAuthCaptcha.captchaToken;
            }

            data._csrf = token;

            var options = {
                url: sat.apiUrl + '/api/payment/stripe/setupintent',
                xhrFields: {
                    withCredentials: true,
                },
                data: data,
            };

            $.post(options)
                .done(function (msg) {
                    _this.stripe.confirmCardSetup(
                        msg.client_secret,
                        {
                            payment_method: {
                                card: cardNumber,
                            },
                        }
                    ).then(function (result) {
                        if (result.error) {
                            var displayError = document.getElementById("card-errors");
                            displayError.textContent = result.error.message;
                        } else {
                            // The PaymentMethod was successfully set up
                            // orderComplete(stripe, setupIntent.client_secret);
                            var data = {
                                api_id: result.setupIntent.payment_method,
                                data: token,
                            };

                            _this.addSource(data, token);
                        }
                    });
                })
                .fail(function (xhr, status, error) {
                    var failData = JSON.parse(xhr.responseText);

                    if (failData.hasOwnProperty('message')) {
                        if (failData.message === 'invalid_captcha') {
                            window.qgAuthCaptcha.callbackCaptcha = function () {
                                window.qgAuthSubscribe.setupIntent(data);
                            };

                            qgCaptcha.captcha();

                            return;
                        }
                    } else {
                        if (xhr.status === 429) {
                            pageNotification.error('Too many requests. Please try again later.');
                        }
                    }
                });
        });
    }

    paymentMethod(cardNumber) {
        csrfManager.getCsrfPayment().then((token) => {
            let _this = this;
            var data = {};

            var user = localStorage.getItem('qgUser');

            if (null !== user) {
                data.user = user;
            }

            if (window.qgAuthCaptcha.captchaToken !== 'no_token') {
                data.captcha = window.qgAuthCaptcha.captchaToken;
            }

            data._csrf = token;

            _this.stripe.createPaymentMethod(
                {
                    type: 'card',
                    card: cardNumber,
                }
            ).then(function (result) {
                if (result.error) {
                    var displayError = document.getElementById("card-errors");
                    displayError.textContent = result.error.message;
                } else {
                    var data = {
                        api_id: result.paymentMethod.id,
                        data: token,
                    };

                    _this.addSource(data, token);
                }
            });
        });
    }

    addSource(data, token) {
        let _this = this;
        var user = localStorage.getItem('qgUser');
        if (null !== user) {
            data.user = user;
        }

        data._csrf = token;

        if (window.qgAuthCaptcha.captchaToken !== 'no_token') {
            data.captcha = window.qgAuthCaptcha.captchaToken;
        }

        var options = {
            url: satGlobals.getApiUrl('/api/payment/stripe/source'),
            cache: false,
            xhrFields: {
                withCredentials: true,
            },
            data: data,
        };

        $.post(options)
            .done(function (msg) {
                _this.addAgreement(token);
            })
            .fail(function (xhr, status, error) {
                var failData = JSON.parse(xhr.responseText);

                if (failData.hasOwnProperty('message')) {
                    if (failData.message === 'invalid_captcha') {
                        window.qgAuthCaptcha.callbackCaptcha = function () {
                            window.qgAuthSubscribe.addSource(data);
                        };

                        qgCaptcha.captcha();

                        return;
                    }
                } else {
                    if (xhr.status === 429) {
                        pageNotification.error('Too many requests. Please try again later.');
                    }
                }
            });
    }

    addAgreement(token) {
        let _this = this;
        var data = {};
        var user = localStorage.getItem('qgUser');
        if (null !== user) {
            data.user = user;
        }

        data._csrf = token;

        if (window.qgAuthCaptcha.captchaToken !== 'no_token') {
            data.captcha = window.qgAuthCaptcha.captchaToken;
        }

        var options = {
            url: satGlobals.getApiUrl(
                '/api/payment/stripe/agreement?plan=' + _this.chosenPlan + '&subscribemethod=modal'
            ),
            cache: false,
            xhrFields: {
                withCredentials: true,
            },
            data: data,
        };

        $.post(options)
            .done(function (msg) {
                var agreementStatus = msg.data.status;
                var paymentIntentStatus = msg.data?.latest_invoice?.payment_intent?.status;
                var paymentIntentSecret = msg.data?.latest_invoice?.payment_intent?.client_secret;

                if (agreementStatus === 'active' || agreementStatus === 'trialing') {
                    window.allowLeave = true;
                    window.location = sat.subscribe_success;

                    return;
                }

                if (testIsNotUndefined(paymentIntentSecret)) {
                    _this.stripe.handleCardPayment(paymentIntentSecret).then(function (result) {
                        if (result.error) {
                            var errorElement = document.getElementById('card-errors');
                            errorElement.textContent = result.error.message;
                            $('#functional-submit-btn')
                                .prop('disabled', false)
                                .find('i')
                                .removeClass('fa-spinner fa-spin');
                            $('#pCreditCard').show();
                            $('#pLoading').hide();
                        } else {
                            satUserManager.getUserDataDeprecated().done((userData) => {
                                window.allowLeave = true;
                                if (userData.isRegistered === true) {
                                    window.location = sat.user_dashboard;
                                } else {
                                    window.location = sat.subscribe_success;
                                }
                            });
                        }
                    });
                } else {
                    $('#functional-submit-btn')
                        .prop('disabled', false)
                        .find('i')
                        .addClass('fa-user-plus')
                        .removeClass('fa-spinner fa-spin');
                }
            })
            .fail(function (xhr, status, error) {
                var failData = JSON.parse(xhr.responseText);

                if (failData.hasOwnProperty('message')) {
                    if (failData.message === 'invalid_captcha') {
                        window.qgAuthCaptcha.callbackCaptcha = function () {
                            window.qgAuthSubscribe.addAgreement();
                        };
                        qgCaptcha.captcha();

                        return;
                    }
                } else {
                    if (xhr.status === 429) {
                        pageNotification.error('Too many requests. Please try again later.');
                    }
                }
                /*
                window.allowLeave = true;
                window.location.href = sat.registerUrl;
                 */
            });
    }
}

window.qgAuthSubscribe = new QgAuthSubscribe();
